import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import projectOptimisationRoutes from 'router/routes/projects/tools/optimisation';
import projectSyncRoutes from 'router/routes/projects/tools/sync';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import projectCrossMinusRoutes from 'router/routes/projects/tools/crossminus';
import projectGenerationRoutes from 'router/routes/projects/tools/generation';
import projectUTMTaggerRoutes from 'router/routes/projects/tools/utmTagger';
import translation from 'translation';

const projectToolsRoutes = [
  {
    path: 'tools',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Tools')
      }
    },
    children: [
      ...projectOptimisationRoutes,
      ...projectSyncRoutes,
      {
        path: 'urlcheck',
        name: 'urlcheck',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Link checking')
          },
          permissions: ['READ_URLCHECK_INCIDENTS']
        },
        component: wrapLegacyRoute('toolsController', 'urlcheck')
      },
      ...projectCrossMinusRoutes,
      ...projectGenerationRoutes,
      ...projectUTMTaggerRoutes,

      {
        path: 'segments',
        name: 'segments',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Audience segments')
          },
          permissions: ['READ_PROJECT_SEGMENTS']
        },
        component: wrapLegacyRoute('toolsController', 'segments')
      }
    ]
  }
];

export default projectToolsRoutes;
